<template>
  <div
    class="form-group"
    :class="{
      'input-group-focus': focused,
      'has-danger': error,
      'has-success': !error && touched,
      'has-label': label
    }"
  >
    <div class="mb-0">
      <slot name="label">
        <label v-if="label"> {{ label }} {{ required ? '*' : '' }} </label>
      </slot>
      <slot>
        <vue-tel-input
          :value="value"
          v-bind="bindProps"
          class="form-control"
          @input="updateModel"
        >
        </vue-tel-input>
      </slot>
    </div>

    <slot name="error" v-if="error || $slots.error">
      <label class="error">{{ error }}</label>
    </slot>
    <slot name="helperText"></slot>
  </div>
</template>
<script>
  import VueTelInput from 'vue-tel-input'


  export default {
    components: {
      VueTelInput,
    },
    inheritAttrs: false,
    name: 'input-phone',
    props: {
      required: Boolean,
      label: {
        type: String,
        description: 'Input label'
      },
      error: {
        type: String,
        description: 'Input error',
        default: ''
      },
      value: {
        type: [String, Number],
        description: 'Input value'
      },
      placeholder: {
        default: 'Enter a phone number'
      }
    },
    model: {
      prop: 'value',
      event: 'input'
    },
    data() {
      return {
        internalValue: '',
        bindProps: {
          defaultCountry: "",
          disabledFetchingCountry: false,
          disabled: false,
          disabledFormatting: false,
          placeholder: this.placeholder,
          required: false,
          enabledCountryCode: false,
          enabledFlags: true,
          onlyCountries: [],
          ignoredCountries: [],
          autocomplete: "off",
          name: "telephone",
          maxLen: 25,
          wrapperClasses: "",
          inputClasses: "",
          dropdownOptions: {
            disabledDialCode: false
          },
          inputOptions: {
            showDialCode: false
          },
          validCharactersOnly: true
        },

        focused: false,
        touched: false
      };
    },
    methods: {
      updateModel: function(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
<style></style>
